import React from 'react';
import PropTypes from 'prop-types';

import { CustomDecimalRenderer } from '../../../shared/numeralRenderers';
import ReportCell from '../../../shared/agGrid/cellRenderers/ReportCell.component';

const unapprovedBalanceIndicator = <div
  className="with-indicator"
  data-tip="Balance includes unapproved tax entries."
  data-for="unapprovedBalanceIndicator"
/>;

const ReportNumeralCellRenderer = ({ value }) => (
  <ReportCell type={value.type} edited={value.data.edited || false}>
    <CustomDecimalRenderer value={value.data.value} />
    {value.data.unapprovedFlag ? unapprovedBalanceIndicator : null}
  </ReportCell>
);

ReportNumeralCellRenderer.propTypes = {
  value: PropTypes.shape({
    data: PropTypes.shape({
      value: PropTypes.number,
      unapprovedFlag: PropTypes.bool,
      edited: PropTypes.bool,
    }).isRequired,
    type: PropTypes.string,
  }).isRequired,
};

export default ReportNumeralCellRenderer;
